/**
 * @fileoverview gRPC-Web generated client stub for receptorutil
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: receptorutil/receptorutil.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var attachment_attachment_pb = require('../attachment/attachment_pb.js')
const proto = {};
proto.receptorutil = require('./receptorutil_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.receptorutil.ReceptorUtilClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.receptorutil.ReceptorUtilPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.GetReceptorMetadataRequest,
 *   !proto.receptorutil.GetReceptorMetadataResponse>}
 */
const methodDescriptor_ReceptorUtil_GetReceptorMetadata = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/GetReceptorMetadata',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.GetReceptorMetadataRequest,
  proto.receptorutil.GetReceptorMetadataResponse,
  /**
   * @param {!proto.receptorutil.GetReceptorMetadataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.GetReceptorMetadataResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.GetReceptorMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.GetReceptorMetadataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.GetReceptorMetadataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.getReceptorMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetReceptorMetadata',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetReceptorMetadata,
      callback);
};


/**
 * @param {!proto.receptorutil.GetReceptorMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.GetReceptorMetadataResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.getReceptorMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetReceptorMetadata',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetReceptorMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.GetDirectoryScanRequest,
 *   !proto.receptorutil.GetDirectoryScanResponse>}
 */
const methodDescriptor_ReceptorUtil_GetDirectoryScan = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/GetDirectoryScan',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.GetDirectoryScanRequest,
  proto.receptorutil.GetDirectoryScanResponse,
  /**
   * @param {!proto.receptorutil.GetDirectoryScanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.GetDirectoryScanResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.GetDirectoryScanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.GetDirectoryScanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.GetDirectoryScanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.getDirectoryScan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetDirectoryScan',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetDirectoryScan,
      callback);
};


/**
 * @param {!proto.receptorutil.GetDirectoryScanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.GetDirectoryScanResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.getDirectoryScan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetDirectoryScan',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetDirectoryScan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.ListDirectoryScanSettingsRequest,
 *   !proto.receptorutil.ListDirectoryScanSettingsResponse>}
 */
const methodDescriptor_ReceptorUtil_ListDirectoryScanSettings = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/ListDirectoryScanSettings',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.ListDirectoryScanSettingsRequest,
  proto.receptorutil.ListDirectoryScanSettingsResponse,
  /**
   * @param {!proto.receptorutil.ListDirectoryScanSettingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.ListDirectoryScanSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.ListDirectoryScanSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.ListDirectoryScanSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.ListDirectoryScanSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.listDirectoryScanSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/ListDirectoryScanSettings',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_ListDirectoryScanSettings,
      callback);
};


/**
 * @param {!proto.receptorutil.ListDirectoryScanSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.ListDirectoryScanSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.listDirectoryScanSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/ListDirectoryScanSettings',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_ListDirectoryScanSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.GetDirectoryScanSettingRequest,
 *   !proto.receptorutil.GetDirectoryScanSettingResponse>}
 */
const methodDescriptor_ReceptorUtil_GetDirectoryScanSetting = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/GetDirectoryScanSetting',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.GetDirectoryScanSettingRequest,
  proto.receptorutil.GetDirectoryScanSettingResponse,
  /**
   * @param {!proto.receptorutil.GetDirectoryScanSettingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.GetDirectoryScanSettingResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.GetDirectoryScanSettingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.GetDirectoryScanSettingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.GetDirectoryScanSettingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.getDirectoryScanSetting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetDirectoryScanSetting',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetDirectoryScanSetting,
      callback);
};


/**
 * @param {!proto.receptorutil.GetDirectoryScanSettingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.GetDirectoryScanSettingResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.getDirectoryScanSetting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetDirectoryScanSetting',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetDirectoryScanSetting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.AddDirectoryScanSettingRequest,
 *   !proto.receptorutil.AddDirectoryScanSettingResponse>}
 */
const methodDescriptor_ReceptorUtil_AddDirectoryScanSetting = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/AddDirectoryScanSetting',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.AddDirectoryScanSettingRequest,
  proto.receptorutil.AddDirectoryScanSettingResponse,
  /**
   * @param {!proto.receptorutil.AddDirectoryScanSettingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.AddDirectoryScanSettingResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.AddDirectoryScanSettingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.AddDirectoryScanSettingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.AddDirectoryScanSettingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.addDirectoryScanSetting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/AddDirectoryScanSetting',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_AddDirectoryScanSetting,
      callback);
};


/**
 * @param {!proto.receptorutil.AddDirectoryScanSettingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.AddDirectoryScanSettingResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.addDirectoryScanSetting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/AddDirectoryScanSetting',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_AddDirectoryScanSetting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.UpdateDirectoryScanSettingRequest,
 *   !proto.receptorutil.UpdateDirectoryScanSettingResponse>}
 */
const methodDescriptor_ReceptorUtil_UpdateDirectoryScanSetting = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/UpdateDirectoryScanSetting',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.UpdateDirectoryScanSettingRequest,
  proto.receptorutil.UpdateDirectoryScanSettingResponse,
  /**
   * @param {!proto.receptorutil.UpdateDirectoryScanSettingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.UpdateDirectoryScanSettingResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.UpdateDirectoryScanSettingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.UpdateDirectoryScanSettingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.UpdateDirectoryScanSettingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.updateDirectoryScanSetting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/UpdateDirectoryScanSetting',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_UpdateDirectoryScanSetting,
      callback);
};


/**
 * @param {!proto.receptorutil.UpdateDirectoryScanSettingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.UpdateDirectoryScanSettingResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.updateDirectoryScanSetting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/UpdateDirectoryScanSetting',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_UpdateDirectoryScanSetting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.DeleteDirectoryScanSettingRequest,
 *   !proto.receptorutil.DeleteDirectoryScanSettingResponse>}
 */
const methodDescriptor_ReceptorUtil_DeleteDirectoryScanSetting = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/DeleteDirectoryScanSetting',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.DeleteDirectoryScanSettingRequest,
  proto.receptorutil.DeleteDirectoryScanSettingResponse,
  /**
   * @param {!proto.receptorutil.DeleteDirectoryScanSettingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.DeleteDirectoryScanSettingResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.DeleteDirectoryScanSettingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.DeleteDirectoryScanSettingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.DeleteDirectoryScanSettingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.deleteDirectoryScanSetting =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/DeleteDirectoryScanSetting',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_DeleteDirectoryScanSetting,
      callback);
};


/**
 * @param {!proto.receptorutil.DeleteDirectoryScanSettingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.DeleteDirectoryScanSettingResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.deleteDirectoryScanSetting =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/DeleteDirectoryScanSetting',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_DeleteDirectoryScanSetting);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.FindWorkflowTicketByTitleRequest,
 *   !proto.receptorutil.FindWorkflowTicketByTitleResponse>}
 */
const methodDescriptor_ReceptorUtil_FindWorkflowTicketByTitle = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/FindWorkflowTicketByTitle',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.FindWorkflowTicketByTitleRequest,
  proto.receptorutil.FindWorkflowTicketByTitleResponse,
  /**
   * @param {!proto.receptorutil.FindWorkflowTicketByTitleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.FindWorkflowTicketByTitleResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.FindWorkflowTicketByTitleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.FindWorkflowTicketByTitleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.FindWorkflowTicketByTitleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.findWorkflowTicketByTitle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/FindWorkflowTicketByTitle',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_FindWorkflowTicketByTitle,
      callback);
};


/**
 * @param {!proto.receptorutil.FindWorkflowTicketByTitleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.FindWorkflowTicketByTitleResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.findWorkflowTicketByTitle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/FindWorkflowTicketByTitle',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_FindWorkflowTicketByTitle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.GetWorkflowTicketStatusRequest,
 *   !proto.receptorutil.GetWorkflowTicketStatusResponse>}
 */
const methodDescriptor_ReceptorUtil_GetWorkflowTicketStatus = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/GetWorkflowTicketStatus',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.GetWorkflowTicketStatusRequest,
  proto.receptorutil.GetWorkflowTicketStatusResponse,
  /**
   * @param {!proto.receptorutil.GetWorkflowTicketStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.GetWorkflowTicketStatusResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.GetWorkflowTicketStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.GetWorkflowTicketStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.GetWorkflowTicketStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.getWorkflowTicketStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetWorkflowTicketStatus',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetWorkflowTicketStatus,
      callback);
};


/**
 * @param {!proto.receptorutil.GetWorkflowTicketStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.GetWorkflowTicketStatusResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.getWorkflowTicketStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetWorkflowTicketStatus',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetWorkflowTicketStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.GetWorkflowUsersRequest,
 *   !proto.receptorutil.GetWorkflowUsersResponse>}
 */
const methodDescriptor_ReceptorUtil_GetWorkflowUsers = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/GetWorkflowUsers',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.GetWorkflowUsersRequest,
  proto.receptorutil.GetWorkflowUsersResponse,
  /**
   * @param {!proto.receptorutil.GetWorkflowUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.GetWorkflowUsersResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.GetWorkflowUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.GetWorkflowUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.GetWorkflowUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.getWorkflowUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetWorkflowUsers',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetWorkflowUsers,
      callback);
};


/**
 * @param {!proto.receptorutil.GetWorkflowUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.GetWorkflowUsersResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.getWorkflowUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/GetWorkflowUsers',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_GetWorkflowUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.CreateWorkflowTicketRequest,
 *   !proto.receptorutil.CreateWorkflowTicketResponse>}
 */
const methodDescriptor_ReceptorUtil_CreateWorkflowTicket = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/CreateWorkflowTicket',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.CreateWorkflowTicketRequest,
  proto.receptorutil.CreateWorkflowTicketResponse,
  /**
   * @param {!proto.receptorutil.CreateWorkflowTicketRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.CreateWorkflowTicketResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.CreateWorkflowTicketRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.CreateWorkflowTicketResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.CreateWorkflowTicketResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.createWorkflowTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/CreateWorkflowTicket',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_CreateWorkflowTicket,
      callback);
};


/**
 * @param {!proto.receptorutil.CreateWorkflowTicketRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.CreateWorkflowTicketResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.createWorkflowTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/CreateWorkflowTicket',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_CreateWorkflowTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.ListJiraWorkflowAssigneesRequest,
 *   !proto.receptorutil.ListJiraWorkflowAssigneesResponse>}
 */
const methodDescriptor_ReceptorUtil_ListJiraWorkflowAssignees = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/ListJiraWorkflowAssignees',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.ListJiraWorkflowAssigneesRequest,
  proto.receptorutil.ListJiraWorkflowAssigneesResponse,
  /**
   * @param {!proto.receptorutil.ListJiraWorkflowAssigneesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.ListJiraWorkflowAssigneesResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.ListJiraWorkflowAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.ListJiraWorkflowAssigneesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.ListJiraWorkflowAssigneesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.listJiraWorkflowAssignees =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/ListJiraWorkflowAssignees',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_ListJiraWorkflowAssignees,
      callback);
};


/**
 * @param {!proto.receptorutil.ListJiraWorkflowAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.ListJiraWorkflowAssigneesResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.listJiraWorkflowAssignees =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/ListJiraWorkflowAssignees',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_ListJiraWorkflowAssignees);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.receptorutil.CreateJiraWorkflowTicketRequest,
 *   !proto.receptorutil.CreateJiraWorkflowTicketResponse>}
 */
const methodDescriptor_ReceptorUtil_CreateJiraWorkflowTicket = new grpc.web.MethodDescriptor(
  '/receptorutil.ReceptorUtil/CreateJiraWorkflowTicket',
  grpc.web.MethodType.UNARY,
  proto.receptorutil.CreateJiraWorkflowTicketRequest,
  proto.receptorutil.CreateJiraWorkflowTicketResponse,
  /**
   * @param {!proto.receptorutil.CreateJiraWorkflowTicketRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.receptorutil.CreateJiraWorkflowTicketResponse.deserializeBinary
);


/**
 * @param {!proto.receptorutil.CreateJiraWorkflowTicketRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.receptorutil.CreateJiraWorkflowTicketResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.receptorutil.CreateJiraWorkflowTicketResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.receptorutil.ReceptorUtilClient.prototype.createJiraWorkflowTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/CreateJiraWorkflowTicket',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_CreateJiraWorkflowTicket,
      callback);
};


/**
 * @param {!proto.receptorutil.CreateJiraWorkflowTicketRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.receptorutil.CreateJiraWorkflowTicketResponse>}
 *     Promise that resolves to the response
 */
proto.receptorutil.ReceptorUtilPromiseClient.prototype.createJiraWorkflowTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/receptorutil.ReceptorUtil/CreateJiraWorkflowTicket',
      request,
      metadata || {},
      methodDescriptor_ReceptorUtil_CreateJiraWorkflowTicket);
};


module.exports = proto.receptorutil;

